import React from "react";
import { Box, Paper, Typography, Button, Avatar } from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import dayjs from "dayjs";

interface PayoutInfoProps {
  bankName: string;
  accountNumber: string;
  schedule: string;
  nextPayoutDate: string;
  nextPayoutAmount: number;
  processingTime: string;
  onEdit?: () => void;
}

const PayoutInfo: React.FC<PayoutInfoProps> = ({
  bankName,
  accountNumber,
  schedule,
  nextPayoutDate,
  nextPayoutAmount,
  processingTime,
  onEdit,
}) => {
  const formatDate = (dateString: string): string => {
    return dayjs(dateString).format("MMM D, YYYY");
  };

  return (
    <Paper elevation={1} sx={{ p: 3, height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Payout Method
        </Typography>
        <Button
          variant="outlined"
          size="small"
          onClick={onEdit}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          Edit
        </Button>
      </Box>

      {/* Bank Account Card */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          p: 2,
          mb: 3,
          backgroundColor: "#F5F5F5",
          borderRadius: 2,
        }}
      >
        <Avatar
          sx={{
            width: 48,
            height: 48,
            backgroundColor: "#178B8E",
          }}
        >
          <AccountBalanceIcon />
        </Avatar>
        <Box>
          <Typography variant="caption" color="text.secondary">
            Bank Account
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {bankName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            •••• {accountNumber}
          </Typography>
        </Box>
      </Box>

      {/* Payout Details */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Payout Schedule
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {schedule}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Next Payout Date
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {formatDate(nextPayoutDate)}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Next Payout Amount
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: 700, color: "#178B8E" }}
          >
            ${nextPayoutAmount.toFixed(2)}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Processing Time
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {processingTime}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default PayoutInfo;
